if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}

function init() {
	const elements = document.querySelectorAll<HTMLElement>('.animate-on-scroll');
	const viewportHeight = window.innerHeight;

	if (!('IntersectionObserver' in window)) {
		elements.forEach((el) => el.classList.add('is-visible'));
		return;
	}

	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add('is-visible');
					obs.unobserve(entry.target); // nur einmal animieren
				}
			});
		},
		{
			threshold: 0.1, // Ausführung bei 15 % im Viewport pro Modul
		}
	);

	elements.forEach((el) => {
		const elHeight = el.offsetHeight;

		// Spezialfall: sehr hohes Modul -> sofort einblenden
		if (elHeight > viewportHeight * 0.9) {
			el.classList.add('is-visible');
			return;
		}

		observer.observe(el);
	});
}
